/* Benji Designs - Working Draft theme */
(function(){
  // Sticky header state (for transparent hero headers)
  var site=document.getElementById('site');
  if(site){
    var onScroll=function(){ site.classList.toggle('scrolled', window.scrollY>40); };
    window.addEventListener('scroll',onScroll,{passive:true}); onScroll();
  }
  // Reveal on scroll
  var io=new IntersectionObserver(function(es){
    es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target);} });
  },{threshold:.16});
  document.querySelectorAll('.reveal').forEach(function(el){ io.observe(el); });

  // Parallax for quote band
  var band=document.querySelector('.band'), bg=band?band.querySelector('.bg'):null;
  if(band&&bg){ window.addEventListener('scroll',function(){ var r=band.getBoundingClientRect();
    if(r.top<innerHeight&&r.bottom>0){ bg.style.transform='translateY('+((r.top/innerHeight)*-40)+'px)'; } },{passive:true}); }

  // Product gallery. Every slide, photo or 360 video, sits in the main frame
  // and a thumb only switches which one is showing. Videos are real players:
  // muted, looping, inline, and paused whenever they are not the one on show.
  // If the browser refuses to autoplay (iPhone Low Power Mode does), the
  // controls appear so the shopper can still start it with one tap.
  function playVid(v){
    v.muted=true;
    var p=v.play();
    if(p&&p.catch){ p.catch(function(){ v.controls=true; }); }
  }
  document.querySelectorAll('[data-gallery]').forEach(function(g){
    var slides=g.querySelectorAll('[data-slide]');
    var thumbs=g.querySelectorAll('[data-thumb]');
    function show(i){
      slides.forEach(function(s){
        var on=s.getAttribute('data-slide')===String(i);
        s.classList.toggle('on',on);
        var v=s.querySelector('video');
        if(v){ if(on){ playVid(v); } else { v.pause(); } }
      });
      thumbs.forEach(function(t){ t.classList.toggle('on', t.getAttribute('data-thumb')===String(i)); });
    }
    thumbs.forEach(function(t){ t.addEventListener('click',function(){ show(t.getAttribute('data-thumb')); }); });
    var first=g.querySelector('[data-slide].on video');
    if(first) playVid(first);
  });

  // Variant selector -> update hidden id + price
  document.querySelectorAll('[data-product-form]').forEach(function(form){
    var data=form.querySelector('[data-variants]');
    if(!data) return;
    var variants=JSON.parse(data.textContent||'[]');
    var idField=form.querySelector('[name=id]');
    var priceEl=document.querySelector('[data-price]');
    var selects=form.querySelectorAll('[data-option]');
    function currency(cents){ return '$'+(cents/100).toLocaleString(undefined,{minimumFractionDigits:0,maximumFractionDigits:0}); }
    function update(){
      var chosen=[]; selects.forEach(function(s){ chosen.push(s.value); });
      var match=variants.find(function(v){ return v.options.join('~~')===chosen.join('~~'); });
      if(match){ if(idField) idField.value=match.id; if(priceEl) priceEl.textContent=currency(match.price);
        form.querySelectorAll('[data-add]').forEach(function(b){ b.disabled=!match.available; b.textContent=match.available?(b.getAttribute('data-label')||'Add to cart'):'Sold out'; }); }
    }
    selects.forEach(function(s){ s.addEventListener('change',update); });
    // Pill-style options. The matching select is found by walking the list
    // and comparing attributes rather than by building a selector string:
    // an index like 0 is not a valid unquoted CSS identifier, and quoting it
    // inside this file has been mangled before. This version cannot break.
    function selectFor(idx){
      var found=null;
      selects.forEach(function(s){ if(s.getAttribute('data-option')===String(idx)) found=s; });
      return found;
    }
    form.querySelectorAll('[data-pillgroup]').forEach(function(grp){
      grp.querySelectorAll('[data-pill]').forEach(function(p){
        p.addEventListener('click',function(){
          grp.querySelectorAll('[data-pill]').forEach(function(x){x.classList.remove('on');});
          p.classList.add('on');
          var sel=selectFor(grp.getAttribute('data-pillgroup'));
          if(sel){ sel.value=p.getAttribute('data-value'); update(); }
        });
      });
    });
    update();
  });
})();